(() => {
  if (document.documentElement.dataset.qrosesHeaderReady) return;
  document.documentElement.dataset.qrosesHeaderReady = 'true';
  const mounted = new Map();
  const mount = slot => {
    if (mounted.has(slot)) return;
    const header = slot.querySelector('.qroses-site-header');
    if (!header) return;
    const menu = header.querySelector('.qroses-mobile-menu');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    let origin = 0;
    let height = 0;
    let previous = window.scrollY;
    let travel = 0;
    let frame = 0;
    let pinned = false;
    const currentY = () => Math.max(0, Math.min(window.scrollY, document.documentElement.scrollHeight - window.innerHeight));
    const keepVisible = () => Boolean(menu?.open || header.contains(document.activeElement));
    const show = () => header.classList.remove('qroses-site-header--hidden');
    const update = () => {
      frame = 0;
      const y = currentY();
      const delta = y - previous;
      previous = y;
      if (y <= origin + height) {
        pinned = false;
        travel = 0;
        slot.removeAttribute('data-header-pinned');
        header.classList.remove('qroses-site-header--floating', 'qroses-site-header--hidden');
        return;
      }
      if (!pinned) {
        pinned = true;
        slot.setAttribute('data-header-pinned', '');
        header.classList.add('qroses-site-header--floating');
        header.classList.toggle('qroses-site-header--hidden', !keepVisible() && delta >= 0);
        travel = 0;
      }
      if (keepVisible()) {
        show();
        travel = 0;
        return;
      }
      if (delta) travel = Math.sign(delta) === Math.sign(travel) ? travel + delta : delta;
      if (travel >= 12) header.classList.add('qroses-site-header--hidden');
      if (travel <= -8) show();
    };
    const requestUpdate = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    const measure = () => {
      origin = slot.getBoundingClientRect().top + window.scrollY;
      height = header.getBoundingClientRect().height;
      slot.style.setProperty('--qroses-header-height', `${height}px`);
      requestUpdate();
    };
    window.addEventListener('scroll', requestUpdate, { ...options, passive: true });
    window.addEventListener('resize', measure, options);
    window.addEventListener('pageshow', measure, options);
    header.addEventListener('focusin', show, options);
    header.addEventListener('focusout', requestUpdate, options);
    menu?.addEventListener('toggle', requestUpdate, options);
    header.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu?.open) {
        menu.open = false;
        menu.querySelector('summary')?.focus();
      }
    }, options);
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
    observer?.observe(header);
    measure();
    mounted.set(slot, () => {
      controller.abort();
      observer?.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
    });
  };
  const mountAll = root => root.querySelectorAll('[data-qroses-header-slot]').forEach(mount);
  mountAll(document);
  document.addEventListener('shopify:section:load', event => mountAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-qroses-header-slot]').forEach(slot => {
      mounted.get(slot)?.();
      mounted.delete(slot);
    });
  });
})();
